import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AuthenticationService } from '../../../core/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';
import { CookieService } from 'src/app/core/services/cookie.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit {
    loginForm: FormGroup;
    submitted = false;
    returnUrl: string;
    error = '';
    loading: boolean;
    success: any;
    userId: any;
    errorMessage: any;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private cookieservice: CookieService,
        private authenticationService: GeneralService
    ) {
        this.loading = false;
    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            EmailORMobile: [
                '',
                [
                    Validators.required,
                    Validators.pattern(
                        /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})|^([0-9]{10})+$/
                    ),
                ],
            ],
            // MobileNumber: ['', Validators.required],
            Password: ['', Validators.required],
        });

        // reset login status
        this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        // tslint:disable-next-line: no-string-literal
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    ngAfterViewInit() {
        document.body.classList.add('authentication-bg');
        document.body.classList.add('authentication-bg-pattern');
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.loginForm.controls;
    }

    /**
     * On submit form
     */
    onSubmit() {
        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.authenticationService
            .login(this.f.EmailORMobile.value, this.f.Password.value)
            .pipe(first())
            .subscribe(
                (data) => {
                    if (data.error) {
                        this.error = data.error;
                        this.loading = false;
                        return;
                    } else if (data.status == 401) {
                        this.error = data.Message;
                        this.loading = false;
                        return;
                    } else {
                        this.submitted = false;
                        Swal.fire({
                            position: 'top-end',
                            type: 'success',
                            title: data.Message,
                            showConfirmButton: false,
                            timer: 1500,
                        });
                        this.loading = false;
                        this.error = '';
                        this.success = data.message;
                        this.userId = data.data.Id;
                        if (data.data.userType && data.data.userType != null) {
                            this.cookieservice.setCookie(
                                'currentUser',
                                JSON.stringify(data.data),
                                1
                            );
                            if (data.data.userType === 'CSR') {
                                this.router.navigate(['/users/users-users']);
                            } else if (data.data.userType === 'Admin') {
                                this.router.navigate(['/']);
                            } else if (data.data.userType === 'DEO') {
                                this.router.navigate(['/deo/view']);
                            } else if (data.data.userType === 'QA') {
                                this.router.navigate(['/deo/view']);
                            } else {
                                this.router.navigate(['/']);
                            }
                        }
                    }
                },
                (error) => {
                    //Error callback
                    this.loading = false;
                    Swal.fire({
                        title: error.status,
                        text: 'Internal Server Error',
                        type: 'error',
                    });
                    //throw error;   //You can also throw the error to a global error handler
                }
            );
    }
}
